<template>
  <b-container id="change-password">
    <mtg-header />
    <b-form @submit.prevent="onSubmit" novalidate>
      <b-container class="container--max-610 mt-3 mt-md-4">
        <b-card>
          <h1 class="h3 mb-4">{{ $t("lang.label_password_change") }}</h1>
          <p>{{ $t("lang.label_password_change_text") }}</p>
          <b-form-group :label="$t('lang.label_password_new')" label-for="newPassword">
            <div class="position-relative">
              <b-form-input
                @keydown.space.prevent
                v-model="newPassword"
                id="newPassword"
                type="password"
                ref="newPassword"
                required
                v-b-tooltip.hover
                :title="$t('lang.tooltip_user_password')"
                :placeholder="$t('lang.label_placeholder_password')"
                minlength="8"
              ></b-form-input>
              <b-form-invalid-feedback>{{ passwordError }}</b-form-invalid-feedback>
            </div>
          </b-form-group>
          <b-form-group :label="$t('lang.label_password_retype')" label-for="confirmPassword">
            <div class="position-relative">
              <b-form-input
                @keydown.space.prevent
                v-model="confirmPassword"
                id="confirmPassword"
                ref="confirmPassword"
                type="password"
                required
                :placeholder="$t('lang.label_password_retype')"
              ></b-form-input>
              <b-form-invalid-feedback>{{ passwordRetypeError }}</b-form-invalid-feedback>
            </div>
            <b-row class="mt-5">
              <b-col sm>
                <b-button variant="primary" type="submit" :disabled="isLoading">{{ $t("lang.label_password_reset") }}</b-button>
              </b-col>
            </b-row>
          </b-form-group>
        </b-card>
      </b-container>
    </b-form>
  </b-container>
</template>
<script>
import MtgHeader from "../components/layout/MtgHeader";
import * as utils from "@/utils";
export default {
  name: "ChangePassword",
  components: {
    MtgHeader
  },
  data() {
    return {
      newPassword: "",
      confirmPassword: "",
      authToken: ""
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters["isLoading"];
    },
    passwordError() {
      if (utils.isEmpty(this.newPassword)) {
        return this.$t("lang.message_user_password_error_invalid");
      } else if (!utils.isOfSufficientLength(this.newPassword, 8)) {
        return this.$t("lang.message_user_password_length_error");
      } else if (!utils.passwordPatternMatch(this.newPassword)) {
        return this.$t("lang.message_user_password_must_contain_number_letter_and_special_character");
      }
      return "";
    },
    passwordRetypeError() {
      if (utils.isEmpty(this.confirmPassword)) {
        return this.$t("lang.message_user_passwordConfirmation");
      } else if (!utils.isEqual(this.confirmPassword, this.newPassword)) {
        return this.$t("lang.message_user_password_error_match");
      } else {
        return "";
      }
    }
  },
  watch: {
    newPassword: function() {
      this.updatePasswordValidity();
    },
    confirmPassword: function() {
      this.updatePasswordConfirmationValidity();
    }
  },
  methods: {
    onSubmit(evt) {
      if (this.validateForm(evt)) {
        this.changePassword();
      }
    },
    validateForm(evt) {
      var isValid = true;
      var elements = evt.target.elements;
      for (let elem of elements) {
        utils.resetValidityClassFromElement(elem); // remove valid or invalid class before start validating
        if (!elem.validity.valid) {
          elem.classList.add("is-invalid");
          isValid = false;
        }
      }
      return isValid;
    },
    async changePassword() {
      try {
        this.authToken = this.$route.params.token;
        await this.$store.dispatch("auth/changePassword", { newPassword: this.newPassword, authToken: this.authToken }).then(() => this.$store.dispatch("certificate/getCertificateStatisticsForUser"));
        await this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_user_password_change_success"));
        this.$router.push("/dashboard");
      } catch (ex) {
        await this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_user_password_change_error"));
      }
    },
    updatePasswordValidity() {
      const passwordElement = this.$refs.newPassword;
      utils.resetValidityClassFromElement(passwordElement.$el);
      passwordElement.setCustomValidity(this.passwordError);
      if (utils.isNotEmpty(this.passwordError)) {
        passwordElement.$el.classList.add("is-invalid");
      }
    },
    updatePasswordConfirmationValidity() {
      const passwordConfirmationElement = this.$refs.confirmPassword;
      utils.resetValidityClassFromElement(passwordConfirmationElement.$el);
      passwordConfirmationElement.setCustomValidity(this.passwordRetypeError);
      if (utils.isNotEmpty(this.passwordRetypeError)) {
        passwordConfirmationElement.$el.classList.add("is-invalid");
      }
    }
  }
};
</script>
